import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  branches: [],
  branch: null,
  isLoading: false,
  success: false,
  error: null,
  message: null,
};

export const branchReducer = createReducer(initialState, (builder) => {
  builder
    // Get All Branches
    .addCase('getAllBranchesRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('getAllBranchesSuccess', (state, action) => {
      state.isLoading = false;
      state.branches = action.payload;
    })
    .addCase('getAllBranchesFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })

    // Branch Creation
    .addCase('branchCreateRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('branchCreateSuccess', (state, action) => {
      state.isLoading = false;
      state.branch = action.payload;
      state.success = true;
    })
    .addCase('branchCreateFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Edit Branch
    .addCase('editBranchRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('editBranchSuccess', (state, action) => {
      state.isLoading = false;
      state.branch = action.payload;
      state.success = true;
    })
    .addCase('editBranchFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Delete Branch
    .addCase('deleteBranchRequest', (state) => {
      state.isLoading = true;
    })
    .addCase('deleteBranchSuccess', (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.message = "Branch deleted successfully!";
      state.branches = state.branches.filter(branch => branch._id !== action.payload);
    })
    .addCase('deleteBranchFail', (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
      state.success = false;
    })

    // Clear Errors
    .addCase('clearErrors', (state) => {
      state.error = null;
    })

    // Clear Success Messages
    .addCase('clearSuccess', (state) => {
      state.message = null;
      state.success = false;
    });
});